import {BooleanUDF} from "./UDFs/BooleanUDF";
import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";

export class AssociationConfiguration {

  AllowAssociationOverride: BooleanUDF;

  AllowKeyboardInputForAssociations: BooleanUDF;

  AllowDefaultProductInsert: BooleanUDF;

  AutoSave: BooleanUDF;

  AutoSaveTimer: NumberUDF;

  FirstBarcodeUDF: StringUDF;

  FirstFieldLabel: StringUDF;

  FirstFieldReaderType: StringUDF;

  FirstFieldValidation: StringUDF;

  FirstThingTypeCode: StringUDF;

  SecondBarcodeUDF: StringUDF;

  SecondFieldLabel: StringUDF;

  SecondFieldReaderType: StringUDF;

  SecondFieldValidation: StringUDF;

  SecondThingTypeCode: StringUDF;

  ThingTypeCodeToSync: StringUDF;

  AssociationZoneUDF: StringUDF;

  DefaultProductSKUUDF: StringUDF;

  DefaultProductUPCUDF: StringUDF;

  ItemUPCUDF: StringUDF;

  ShowZonePickList:BooleanUDF;

  DefaultAssociationZone:StringUDF;

  get(): any {
    return {
      AllowAssociationOverride: this.AllowAssociationOverride.value,
      AllowKeyboardInputForAssociations: this.AllowKeyboardInputForAssociations.value,
      AllowDefaultProductInsert: this.AllowDefaultProductInsert.value,
      AutoSave: this.AutoSave.value,
      AutoSaveTimer: this.AutoSaveTimer.value,
      FirstBarcodeUDF: this.FirstBarcodeUDF.value,
      FirstFieldLabel: this.FirstFieldLabel.value,
      FirstFieldReaderType: this.FirstFieldReaderType.value,
      FirstFieldValidation: this.FirstFieldValidation.value,
      FirstThingTypeCode: this.FirstThingTypeCode,
      SecondBarcodeUDF: this.SecondBarcodeUDF.value,
      SecondFieldLabel: this.SecondFieldLabel.value,
      SecondFieldReaderType: this.SecondFieldReaderType.value,
      SecondFieldValidation: this.SecondFieldValidation.value,
      SecondThingTypeCode: this.SecondThingTypeCode,
      ThingTypeCodeToSync: this.ThingTypeCodeToSync.value,
      ItemUPCUDF: this.ItemUPCUDF,
      ShowZonePickList:this.ShowZonePickList,
      DefaultAssociationZone:this.DefaultAssociationZone
    };
  }
}



// WEBPACK FOOTER //
// ./src/models/association.config.ts